import React, { useState } from 'react';
import {
  Typography,
  Box,
  Button,
  Alert,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';

interface DatasetUploadProps {
  onFileSelect?: (file: File, content: string) => void;
  onError?: (message: string) => void;
}

const DatasetUpload: React.FC<DatasetUploadProps> = ({ onFileSelect, onError }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      
      // Read file content
      try {
        const content = await file.text();
        if (onFileSelect) {
          onFileSelect(file, content);
        }
      } catch (error) {
        console.error('Error reading file:', error);
        if (onError) {
          onError('Error reading file: ' + (error instanceof Error ? error.message : String(error)));
        }
      }
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <DescriptionIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6" component="h2">
          Dataset
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Upload QWS dataset file (CSV format)
        </Typography>

        <input
          accept=".csv,.txt"
          style={{ display: 'none' }}
          id="dataset-upload-input"
          type="file"
          onChange={handleFileSelect}
        />
        <label htmlFor="dataset-upload-input">
          <Button
            variant="outlined"
            component="span"
            fullWidth
            startIcon={<CloudUploadIcon />}
          >
            Browse Dataset
          </Button>
        </label>

        {selectedFile && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Selected: {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
          </Alert>
        )}
      </Box>

      <Typography variant="caption" color="text.secondary">
        Expected format: ResponseTime, Availability, Throughput, Successability,
        Reliability, Compliance, BestPractices, Latency, Documentation, ServiceName, WSDL_URL
      </Typography>
    </Box>
  );
};

export default DatasetUpload;

